import { render, staticRenderFns } from "./SpToilet.vue?vue&type=template&id=0315d24e"
import script from "./SpToilet.vue?vue&type=script&lang=js"
export * from "./SpToilet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports